import { render, staticRenderFns } from "./CourseFacultyListing.vue?vue&type=template&id=e3308f28&"
import script from "./CourseFacultyListing.vue?vue&type=script&lang=js&"
export * from "./CourseFacultyListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports